import Module from "../module";
import { en, nl } from "chartjs-graph/translations";
import baseRoute from "./routes/index";

export default new Module(baseRoute, { en, nl }, ["can_manage_explorer"]);
